import { CSSProperties } from "react";

export const CustomColumnHeaderStyles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    height: "100%",
    padding: "0 8px",
    gap: "8px",
  } as CSSProperties,

  contentContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flex: 1,
    minWidth: 0,
  } as CSSProperties,

  hoverContainer: {
    display: "flex",
    alignItems: "center",
    position: "relative",
  } as CSSProperties,

  headerTextContainer: {} as CSSProperties,

  sortButton: {
    border: "none",
    background: "transparent",
    padding: "4px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    borderRadius: "4px",
    marginLeft: "4px",
    transition: "opacity 0.2s ease",
  } as CSSProperties,

  sortButtonActive: {
    color: "#1976d2",
    opacity: "1",
  } as CSSProperties,

  sortButtonInactive: {
    color: "#999",
    opacity: "0",
  } as CSSProperties,

  sortButtonHover: {
    backgroundColor: "rgba(0,0,0,0.04)",
  } as CSSProperties,

  sortButtonDefault: {
    backgroundColor: "transparent",
  } as CSSProperties,

  menuButton: {
    flexShrink: 0,
    height: "100%",
  } as CSSProperties,

  menuButtonHover: {
    backgroundColor: "rgba(0,0,0,0.04)",
  } as CSSProperties,

  menuIcon: {
    marginRight: 1,
    fontSize: "1.2rem",
  },

  menuIconActive: {
    color: "primary.main",
  },

  menuIconInactive: {
    color: "text.disabled",
  },

  menuIconTransforms: {
    pinLeft: "rotate(-45deg)",
    pinRight: "rotate(45deg)",
  },
};
